export default __webpack_public_path__ + "static/media/layer-guardrails.69b38c7d.svg";